// Mapping entre les champs de la DB et les labels/colonnes du dashboard
// À compléter selon les besoins du dashboard

const DB_TO_DASHBOARD_MAPPING = {
  country: "Country",
  buyer: "Buyer entity",
  delivery: "Delivery entity",
  product: "Product",
  years: ["2021", "2022", "2023", "2024", "2025"],
  // ...
}

export default DB_TO_DASHBOARD_MAPPING 